import React from 'react'
import { ArrowRightOutlined, DateRangeOutlined, RemoveRedEye } from '@mui/icons-material'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const SaleMap = ({ sale }) => {
  const { t } = useTranslation()

  return (
    <div>
      {sale?.map((s, index) => (
        <div
          className={`lg:flex justify-between gap-16 py-6
                            ${index !== sale.length - 1 ? 'border-b border-b-border' : ''}
                            ${index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'}`}
          key={s.id}
        >
          <section className='lg:w-[30%]'>
            <img
              src={s.photo1}
              alt="auction"
              loading="lazy"
              className='object-contain w-full rounded-lg max-h-[300px]'
            />
          </section>

          <section className='lg:w-[70%] dark:text-dark-text mt-6 
                                    h-full animate-slide-in lg:mt-0'>
            <div className='flex  pb-2
                                  items-center gap-8 dark:border-b-dark-border'>
              <h2 className='text-primary font-bold text-xl
                             dark:text-dark-text'>
                {t('court_order')}
              </h2>
              <p className='flex items-center gap-1'>
                <DateRangeOutlined style={{ fontSize: '20px' }} />
                <span className='text-primary dark:text-dark-text
                                  text-2xl font-bold'>
                  {s.lot}
                </span>
              </p>
            </div>

            <div className='flex items-center my-2 gap-2'>
              {t('type')}:
              <p>
                {s.category}
              </p>
            </div>

            <div className='flex gap-2 items-center'>
              {t('commission_basis')} :
              <p className='text-primary text-xl dark:text-dark-text'>
                {s.price}
              </p>
            </div>

            <div className='flex gap-4 items-center mt-2'>
              <p>{t('trading_place')}:</p>
              <p className='line-clamp-2 overflow-hidden '>
                {s.location}
              </p>
            </div>

            <div className='flex gap-4 items-center mt-2'>
              <p className='xl:mt-0'>{t('contact_us')}:</p>
              <a href={`tel:${sale.phone_number}`}>
                {s.phone_number}
              </a>
            </div>

            <span className='flex justify-between items-center gap-4 mt-8'>
                <p className='text-blackOpacity dark:text-dark-text
                              flex items-center gap-1'>
                  <RemoveRedEye style={{ fontSize: '20px' }} />
                  {s.view_count}
                </p>

              <div className="xl:text-center xl:mt-2">
                <Link
                  to={`/sale/${s.id}`}
                  className="text-white bg-primary py-2 px-4 rounded-lg
                             dark:text-dark-text hover:text-primary
                             hover:bg-white hover:border dark:hover:bg-dark 
                             transition-all duration-300 ease-in-out 
                             transform hover:translate-x-1 font-semibold"
                >
                  {t('all_button')}
                  <ArrowRightOutlined style={{ marginBottom: '1px' }} />
                </Link>
              </div>
            </span>
          </section>
        </div>
      ))}
    </div>
  )
}

export default SaleMap